import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, Auth } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator, Firestore } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator, Functions } from 'firebase/functions';
import { getStorage, connectStorageEmulator, FirebaseStorage } from 'firebase/storage';
import { getAnalytics, isSupported, Analytics } from 'firebase/analytics';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDKa0rw-dmXzdOYAWcgIrlnTUg8zc3Z9-U",
  authDomain: "nfilumper-df447.firebaseapp.com",
  projectId: "nfilumper-df447",
  storageBucket: "nfilumper-df447.appspot.com",
  messagingSenderId: "787524356925",
  appId: "1:787524356925:web:dc3f821865725e72d95354",
  measurementId: "G-Y9HGPNEKS4"
};

// Initialize Firebase with error handling
let app: FirebaseApp;
let auth: Auth;
let db: Firestore;
let functions: Functions;
let storage: FirebaseStorage;
let analytics: Analytics | null = null;

try {
  console.log('Initializing Firebase...');
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  functions = getFunctions(app);
  storage = getStorage(app);
  
  // Only initialize analytics if it's supported by the current environment
  isSupported().then(supported => {
    if (supported) {
      analytics = getAnalytics(app);
      console.log('Firebase Analytics initialized');
    } else {
      console.log('Firebase Analytics not supported in this environment');
    }
  });
  
  console.log('Firebase initialized successfully');
} catch (error) {
  console.error('Error initializing Firebase:', error);
  // Initialize with default values to prevent undefined errors
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  functions = getFunctions(app);
  storage = getStorage(app);
}

// Check if we're in development mode to use emulators
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_EMULATOR === 'true') {
  try {
    // Connect to emulators if available
    const host = process.env.REACT_APP_EMULATOR_HOST || 'localhost';
    
    // Connect to Auth emulator
    connectAuthEmulator(auth, `http://${host}:9099`);
    
    // Connect to Firestore emulator
    connectFirestoreEmulator(db, host, 8080);
    
    // Connect to Functions emulator
    connectFunctionsEmulator(functions, host, 5001);
    
    // Connect to Storage emulator
    connectStorageEmulator(storage, host, 9199);
    
    console.log('Connected to Firebase emulators');
  } catch (error) {
    console.error('Error connecting to Firebase emulators:', error);
  }
}

export { app, auth, db, functions, storage, analytics }; 